import React, { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';

import { PreLoader } from './PreLoader';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Messages = () => (
  <>
    <DocumentHead title="Messages" />
    <PageTemplate main={<Wrapper />} />
  </>
);
